<script>
import { mapState, mapMutations } from 'vuex';
import { get } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFilm, faFileAlt, faHandshake } from '@fortawesome/free-solid-svg-icons';

import LecturesMenu from './LecturesMenu';
import config from '@/config/config';

library.add( faFilm, faFileAlt, faHandshake );

export default {
  name: 'ComponentsCourseLecture',
  components: {
    LecturesMenu,
  },
  computed: {
    ...mapState(config.app, [
      'course',
      'currentLectureIndex',
    ]),
    finalWords() {
      return get(this, 'course.finalWords', null);
    },
    lectures() {
      return get(this, 'course.lectures', []);
    },
    lecture() {
      return !this.lectures[this.currentLectureIndex] ? {} : this.lectures[this.currentLectureIndex];
    },
    isLast() {
      return this.currentLectureIndex >= (this.lectures.length - 1);
    },
    hasExam() {
      return this.course.exam && this.course.exam.id;
    },
    flow() {
      return config.initial.course;
    },
  },
  methods: {
    ...mapMutations(config.app, [
      'setCurrentCourse',
      'setCurrentLectureIndex',
      'setCurrent',
    ]),
  },
};
</script>
<template>
    <div id="course-lecture">
        <LecturesMenu />
        <ul class="menu">
            <li v-if="lecture.video" class="d-flex mb-5">
                <font-awesome-icon icon="film" />
                <span>Film</span>
                <button class="btn" @click="setCurrentCourse(flow.video)">
                    ZOBACZ
                </button>
            </li>
            <li v-if="lecture.material" class="d-flex mb-5">
                <font-awesome-icon icon="file-alt" />
                <span>Materiał do pobrania</span>
                <button class="btn align-self-center" @click="setCurrentCourse(flow.materials)">
                    ZOBACZ
                </button>
            </li>
            <li v-if="isLast && finalWords && finalWords.length > 0" class="d-flex">
                <font-awesome-icon icon="handshake" />
                <span>Podziękowanie</span>
                <button class="btn align-self-center" @click="setCurrentCourse(flow.finish)">
                    ZOBACZ
                </button>
            </li>
            <li v-if="isLast && hasExam" class="d-flex mt-5">
                <font-awesome-icon icon="handshake" />
                <span>Egzamin</span>
                <button class="btn align-self-center" @click="setCurrent('exam')">
                    Przystąp do Egzaminu
                </button>
            </li>
        </ul>
    </div>
</template>
